import { combineReducers } from '@reduxjs/toolkit';

import { queryClient } from '~/index';
import state from './state';
import ui from './ui';
import pageShow from './pageShow';

const appReducer = combineReducers({
  state,
  ui,
  pageShow,
});

const rootReducer: typeof appReducer = (rootState, action) => {
  if (action.type === 'reset/state') {
    void queryClient.invalidateQueries();
    // eslint-disable-next-line no-param-reassign
    rootState = undefined;
  }
  return appReducer(rootState, action);
};

export default rootReducer;
